<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>

          <div class="row">
            <!-- organizationId -->
            <div class="md:tw-w-1/2 xl:tw-w-1/4">
              <organization-select-search
                *ngIf="!this.formPageConfig.isEditMode"
                type="descendantList"
                [isDisabled]="formPageConfig.isEditMode"
                [control]="form?.get('organizationId')"
                [(value)]="model.organizationId"
                (valueChange)="emptyTargetPrivateNumbers()"
                (onError)="onClose()"
              >
              </organization-select-search>

              <form-field
                *ngIf="this.formPageConfig.isEditMode"
                [(value)]="model.organizationName"
                [control]="form?.get('organizationName')"
                label="common.organization"
              >
              </form-field>
            </div>

            <!-- targetPrivateNumbers -->
            <div class="md:tw-w-1/2 xl:tw-w-1/4">
              <private-numbers-chip-list-select-search
                [label]="fields + 'targetPrivateNumbers'"
                [id]="model.organizationId"
                [isShowSelectAll]="true"
                [control]="form?.get('targetPrivateNumbers')"
                [(values)]="model.targetPrivateNumbers"
                (onError)="onClose()"
              >
              </private-numbers-chip-list-select-search>
            </div>

            <!-- deliveryStatus -->
            <div class="md:tw-w-1/2 xl:tw-w-1/4">
              <enum-select-search
                class="tw-w-full"
                enumName="DeliveryStatus"
                [label]="fields + 'deliveryStatus'"
                [removable]="false"
                [isDisabled]="this.formPageConfig.isEditMode"
                [control]="form?.get('deliveryStatus')"
                [(value)]="model.deliveryStatus"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- privateNumberId -->
            <div class="md:tw-w-1/2 xl:tw-w-1/4">
              <private-number-select-search
                label="common.privateNumber"
                [control]="form?.get('privateNumberId')"
                [(value)]="model.privateNumberId"
                (onError)="onClose()"
              >
              </private-number-select-search>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
